import React, { useState } from 'react'

import { BackToTheTop } from './styles'
import { IoTriangle } from 'react-icons/io5'

export default function Scroll () {
  const [visible, setVisible] = useState(false)

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop
    if (scrolled > 300) {
      setVisible(true)
    } else if (scrolled <= 300) {
      setVisible(false)
    }
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
      /* you can also use 'auto' behaviour
                                   in place of 'smooth' */
    })
  }

  window.addEventListener('scroll', toggleVisible)

  return (

        <BackToTheTop
            onClick={scrollToTop}
            style={{ display: visible ? 'inline' : 'none' }}>
            <IoTriangle color="white"/>
            <p> Voltar <br />ao topo</p>
        </BackToTheTop >

  )
}
